define('controllers/fieldHTML',[], function() {
    var controller = Marionette.Object.extend({

        htmlFields: [],
        trackedMergeTags: [],

        initialize: function () {
            this.listenTo( Backbone.Radio.channel( 'fields-html' ), 'init:model', this.setupFieldMergeTagTracking );
        },

        setupFieldMergeTagTracking: function( fieldModel ) {
            this.htmlFields.push( fieldModel );

            var formID = fieldModel.get( 'formID' );
            var self = this;

            this.listenTo( nfRadio.channel( 'form-' + formID ), 'init:model', function( formModel ){

                var mergeTags = fieldModel.get( 'default' ).match( new RegExp( /{field:(.*?)}/g ) );
                if ( ! mergeTags ) return;

                _.each( mergeTags, function( mergeTag ) {
                    var fieldKey = mergeTag.replace( '{field:', '' ).replace( '}', '' );
                    var fieldModel = formModel.get( 'fields' ).findWhere({ key: fieldKey });
                    if( 'undefined' == typeof fieldModel ) return;

                    this.trackedMergeTags.push( fieldModel );
                    this.listenTo( nfRadio.channel( 'field-' + fieldModel.get( 'id' ) ), 'change:modelValue', this.updateFieldMergeTags );

                    // Special handling for repeater fields
                    if (fieldModel.get('type') === 'repeater') {
                        // Listen to all field changes to catch repeater sub-field updates
                        this.listenTo( nfRadio.channel( 'fields' ), 'change:modelValue', function(changedField) {

                            // Check if this is a sub-field of our repeater
                            var changedKey = changedField.get('key');
                            if (changedKey && changedKey.indexOf(fieldKey + '_') === 0) {
                                // This is a sub-field of our repeater, trigger update
                                self.updateFieldMergeTags(fieldModel);
                            }
                        });
                    }
                }, this );

                // Let's get this party started!
                this.updateFieldMergeTags();
            }, this );
        },

        updateFieldMergeTags: function( fieldModel ) {
            var self = this;
            _.each( this.htmlFields, function( htmlFieldModel ){
                var defaultValue = htmlFieldModel.get( 'default' ) || '';

                // Skip HTML fields that contain no field merge tags — other merge tag
                // types (e.g. querystring) are resolved server-side into 'value' and
                // must not be overwritten. See issue #6233.
                if ( ! /{field:(.*?)}/.test( defaultValue ) ) return;

                // On first call, establish the merge base — a version of the content
                // where {field:key} placeholders are intact for client-side replacement
                // and other merge tags (e.g. querystring) are already resolved.
                // Stored as a direct property to avoid triggering Backbone change events.
                if ( ! htmlFieldModel._nfFieldMergeBase ) {
                    // Calc values are kept as {calc:name} in the base too, so a frozen
                    // number never outlives the calculation. See issue #8106.
                    var serverValue = ( htmlFieldModel.get( 'value' ) || defaultValue )
                        .replace( /<span data-key="field:(.*?)">([\s\S]*?)<\/span>/g, '{field:$1}' )
                        .replace( /<span data-key="calc:(.*?)">([\s\S]*?)<\/span>/g, '{calc:$1}' );

                    // Check whether {field:*} placeholders survived PHP rendering.
                    // PHP may resolve them to empty string, leaving a truthy value
                    // string that no longer contains the placeholder.
                    var fieldTags = defaultValue.match( /{field:(.*?)}/g ) || [];
                    var allFieldTagsPresent = fieldTags.every( function( tag ) {
                        return serverValue.indexOf( tag ) !== -1;
                    } );

                    if ( allFieldTagsPresent ) {
                        // Server value preserved {field:*} tags (or spans we stripped back).
                        // Use it directly — querystring tags are already resolved in it.
                        htmlFieldModel._nfFieldMergeBase = serverValue;
                    } else {
                        // PHP resolved {field:*} tags away (e.g. to empty string).
                        // Rebuild from default and resolve querystring tags client-side
                        // so both merge tag types work in the same HTML field.
                        var base = defaultValue;
                        var qsTags = defaultValue.match( /{querystring:(.*?)}/g ) || [];
                        _.each( qsTags, function( tag ) {
                            var key = tag.replace( '{querystring:', '' ).replace( '}', '' );
                            // The URL value is untrusted and the template renders this
                            // field unescaped, so encode it as the server path does. A
                            // replacer function keeps "$`" / "$'" in the value literal.
                            var encoded = _.escape( self._getQueryStringValue( key ) );
                            base = base.replace( tag, function() { return encoded; } );
                        } );
                        htmlFieldModel._nfFieldMergeBase = base;
                    }
                }

                // Always resolve from the base — preserves server-side merge tag
                // resolutions while supplying fresh {field:key} tags on every call.
                var value = htmlFieldModel._nfFieldMergeBase;

                // Calculations write their current value into this same field value
                // as <span data-key="calc:name"> (see calculations.js). Carry those
                // spans over so changing a field that is not part of the calculation
                // does not revert it to the raw {calc:name} tag. See issue #8106.
                var calcSpans = {};
                ( htmlFieldModel.get( 'value' ) || '' ).replace( /<span data-key="calc:(.*?)">([\s\S]*?)<\/span>/g, function( span, name ) {
                    calcSpans[ name ] = span;
                    return span;
                } );
                value = value.replace( /{calc:(.*?)}/g, function( tag, name ) {
                    // Same name normalisation as calculations.js ({calc:key:2}).
                    return calcSpans[ name.replace( ':2', '' ) ] || tag;
                } );

               _.each( self.trackedMergeTags, function( fieldModel ){

                    var mergeTag = '{field:' + fieldModel.get( 'key' ) + '}';

                    let fieldValue;
                    // Handle different field types
                    if (fieldModel.get('type') === "repeater") {
                        fieldValue = self.displayRepeaterData(fieldModel);
                    } else if (fieldModel.get('type') === "signature") {
                        fieldValue = self.displaySignatureData(fieldModel);
                    } else if (fieldModel.get('type') === "checkbox") {
                        // Fix for issue #3538: Use checked_value/unchecked_value instead of 1/0
                        // Values are resolved server-side by localize_field() with full fallback chain
                        if (fieldModel.getValue() == 1 || fieldModel.getValue() == 'on') {
                            fieldValue = fieldModel.get('checked_value') || 'Checked';
                        } else {
                            fieldValue = fieldModel.get('unchecked_value') || 'Unchecked';
                        }
                    } else {
                        fieldValue = fieldModel.getValue();
                    }

                    // Replacer function: "$`" / "$'" in a field value must stay literal.
                    value = value.replace( mergeTag, function() { return fieldValue; } );
               }) ;
               htmlFieldModel.set( 'value', value );
               htmlFieldModel.trigger( 'reRender' );
            });
        },

        displayRepeaterData: function(fieldModel) {
                // Get the current value which contains all sub-field IDs
                var repeaterValue = fieldModel.getValue();
                if (!repeaterValue || typeof repeaterValue !== 'object') {
                    return '';
                }

                const repeaterFieldIDs = Object.keys(repeaterValue);
                let returnHTML = "", passedFields = [];

                _.each(repeaterFieldIDs, function(fieldID){
                    if(passedFields.indexOf(fieldID) === -1) {
                        const field = nfRadio.channel( 'fields' ).request( 'get:field', fieldID );
                        if(typeof field !== "undefined"){
                            const excluded = ['submit', 'html', 'hidden', 'password', 'passwordconfirm', 'divider', 'hr', 'note', 'unknown', 'button', 'confirm', 'creditcard', 'creditcardcvc', 'creditcardexpiration', 'creditcardfullname', 'creditcardnumber', 'creditcardzip', 'recaptcha', 'recaptcha_v3' ];
                            if(excluded.indexOf(field.get('type')) === -1 && field.getValue().toString().length > 0){
                                const index = Number(fieldID.split("_").pop()) + 1;

                                let fieldValue;
                                if (field.get('type') === 'signature') {
                                    fieldValue = this.displaySignatureData(field);
                                } else {
                                    fieldValue = field.getValue();
                                }

                                returnHTML += "<p>"+ field.get("label") + " " + index + " : " + fieldValue + "</p>";
                                passedFields.push(fieldID);
                            }
                        }
                    }
                }, this);

                return returnHTML;
        },

        /**
         * Display signature field data as HTML image or styled text
         *
         * @param {Object} fieldModel The signature field model
         * @returns {string} HTML string containing the signature display
         */
        displaySignatureData: function(fieldModel) {
            var value = fieldModel.getValue();

            // Return empty if no value
            if (!value || value === '') {
                return '';
            }

            // Try to parse JSON data
            var signatureData;
            try {
                // If it's already an object, use it directly
                if (typeof value === 'object') {
                    signatureData = value;
                } else if (typeof value === 'string' && value.charAt(0) === '{') {
                    // Parse JSON string
                    signatureData = JSON.parse(value);
                } else {
                    // Not JSON, return as-is
                    return value;
                }
            } catch (e) {
                // If JSON parsing fails, return the original value
                console.warn('Failed to parse signature data:', e);
                return value;
            }

            // Check if we have valid signature data
            if (!signatureData || !signatureData.signature_type) {
                return value;
            }

            // Handle typed signatures
            if (signatureData.signature_type === 'typed' && signatureData.typed_name) {
                // Get font from field settings first, then signature data, then default
                // This ensures the HTML field merge tag uses the field's configured font
                var configuredFont = fieldModel.get('signature_font');
                var font = configuredFont || signatureData.signature_font || 'dancing-script';
                var fontFamily = this.getSignatureFontFamily(font);

                return '<div class="nf-signature-typed" style="font-family: ' + fontFamily + '; font-size: 28px; color: #000000; padding: 10px 0;">' +
                       _.escape(signatureData.typed_name) +
                       '</div>';
            }

            // Handle drawn signatures
            if (signatureData.signature_type === 'drawn' && signatureData.signature_data) {
                // Ensure the signature data is a valid data URI
                if (signatureData.signature_data.indexOf('data:image') === 0) {
                    return '<img class="nf-signature-drawn" src="' + _.escape(signatureData.signature_data) + '" ' +
                           'alt="Signature" style="max-width: 400px; height: auto; display: block;" />';
                }
            }

            // If we couldn't process the signature, return empty
            return '';
        },

        /**
         * Get the appropriate font family for signature display
         * Matches the valid fonts defined in PHP (Signature.php VALID_FONTS constant)
         * Uses single quotes to avoid HTML escaping issues
         *
         * @param {string} font The font identifier
         * @returns {string} CSS font-family value
         */
        getSignatureFontFamily: function(font) {
            var fontMap = {
                'dancing-script': '\'Dancing Script\', cursive',
                'satisfy': '\'Satisfy\', cursive',
                'cursive': 'cursive'
            };

            return fontMap[font] || fontMap['dancing-script'];
        },

        /**
         * Get a query string parameter value from the current URL.
         *
         * @param {string} key The query string parameter name
         * @returns {string} The decoded parameter value, or empty string if not present
         */
        _getQueryStringValue: function( key ) {
            try {
                return new URLSearchParams( window.location.search ).get( key ) || '';
            } catch ( e ) {
                var escapedKey = key.replace( /[.*+?^${}()|[\]\\]/g, '\\$&' );
                var match = window.location.search.match(
                    new RegExp( '[?&]' + escapedKey + '=([^&]*)' )
                );
                return match ? decodeURIComponent( match[1].replace( /\+/g, ' ' ) ) : '';
            }
        },

    });

    return controller;
});

